export default {
  topicManagerRange_Week_top_list:'周榜',
  topicManagerRange_mouth_top_list:'月榜',
  topicManagerRange_results_count:'找到{count}條記錄，顯示{from}到{to}條',
  topicManagerRange_ranking:'排名',
  topicManagerRange_user:'用戶',
  topicManagerRange_organization:'所屬組織',
  topicManagerRange_likes_num:'點贊量',
  topicManagerRange_top_week:"圈主排行榜-周榜",
  topicManagerRange_top_mouth:'圈主排行榜-月榜'

}
